import React, { useState, useRef } from 'react';
import axios from "axios";
import { searchMedicationDrugsMetaDoc } from "../services/Service";
import DatePicker from 'react-datepicker';
import moment from 'moment';

const MedicationsSupplierList = (props) => {
    const c = props.c;
    const listType = props.listType;
    const showRemoveButton = props.showRemoveButton;
    const data = props.data;
    const removeComponent = props.removeComponent;
    const handleFieldChange = props.handleFieldChange;
    const handleSuggestionClick = props.handleSuggestionClick;
    const frequencyData = props.frequencyData;

    const [drugs, setDrugs] = useState([]);
    const [searchStr, setSearchStr] = useState("");
    const [showSearchBox, setShowSearchBox] = useState(false);
    const searchBoxRef = useRef(null);

    const [loading, setLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false);

    const handleFocus = () => {
        setShowSearchBox(true);
    };

    const handleBlur = (e) => {
        if (searchBoxRef.current && searchBoxRef.current.contains(e.relatedTarget)) {
            return;
        }
        setShowSearchBox(false);
    };

    const handleSearch = (e) => {
        setDrugs([]);
        setSearchStr(e.target.value);

        if (e.target.value != "") {
            setLoading(true);
            setSubmitted(true);
            getMedicationDrugs(e.target.value);
        }
    }

    const hideSearch = () => {
        setShowSearchBox(false);
    }

    const getMedicationDrugs = async (searchStr) => {
        const request = axios.CancelToken.source();
        let ct = {
            cancelToken: request.token
        }
        await searchMedicationDrugsMetaDoc(searchStr, listType, ct)
            .then((response) => {
                if (response.data.data.drugs) {
                    setDrugs(response.data.data.drugs);
                } else {
                    setDrugs([]);
                }
                setLoading(false);
            }).catch(function (error) {
                console.log(error);
            });
        return () => request.cancel();
    }

    const handleSuggestionDrugClick = (suggestion) => {
        handleSuggestionClick(suggestion, listType, c)
        setSearchStr("");
        setShowSearchBox(false);
        setDrugs([]);
    };

    const addHandleChange = (e) => {
        if (e.target.name == "quantity") {
            if (!/^\d*$/.test(e.target.value)) {
                return;
            }
        }

        handleFieldChange(e, c, listType);

        if (e.target.name == "duration" && data.supplyFrom != "") {
            if(e.target.value.length > 0){
                calculateToDate(data.supplyFrom,e.target.value,c,listType);
            }else{
                const tempE = { name: 'supplyTo', value: '' };
                const e = { target: tempE };
                handleFieldChange(e, c, listType);
            }
            
        }
    }

    const addHandleDateChange = (date, name) => {
        const tempE = { name: name, value: (moment(date).isValid()) ? moment(date).format('YYYY-MM-DD') : "" };
        const e = { target: tempE };
        handleFieldChange(e, c, listType);
        
        if(name == "supplyFrom"){
            calculateToDate(e.target.value,data.duration,c);
        }
    }

    const calculateToDate = (fromDateTemp,durationTemp,cTemp) => {
        const fromDate = new Date(fromDateTemp);
        fromDate.setDate(fromDate.getDate() + parseInt(durationTemp));

        const toDate = fromDate.toISOString().split('T')[0];
        const tempE = { name: 'supplyTo', value: toDate };
        const e = { target: tempE };
        handleFieldChange(e, cTemp, listType);

    }

    return (
        <>
            <tr style={{ verticalAlign: "middle" }}>
                <td className='ps-0'>
                    <input type="text" readOnly={true} className="form-control control-input-ui" id="productName" name="productName" style={{ width: "auto !important" }} placeholder="Medicine Name" value={data.productName ? data.productName : ""} onFocus={handleFocus}
                        onBlur={handleBlur}
                    />
                    {showSearchBox > 0 && (
                        <div ref={searchBoxRef} style={{
                            position: 'absolute',
                            border: '1px solid #ccc',
                            backgroundColor: 'rgb(249 251 255)',
                            zIndex: 1,
                            padding: '10px 14px',
                            borderRadius: '14px',
                            width: '64%',
                            bottom: '14px',
                            boxShadow: "rgba(0, 0, 0, 0.15) 0px 5px 15px 0px"
                        }}
                        >
                            <div style={{ width: "100%" }}>
                                <label className="form-label">Search:</label>
                                <button type="button" class="btn-close" aria-label="Close" style={{ float: 'right', padding: '5px' }} onClick={hideSearch}></button>
                                <input className='form-control control-input-ui' type="text" name="searchStr" value={searchStr} onChange={handleSearch} />
                            </div>

                            <div style={{ overflowY: 'auto', height: '240px' }}>
                                {loading &&
                                    <div className='tw-flex tw-items-center tw-justify-center tw-h-full tw-w-full'>
                                        <svg className='tw-h-16 tw-w-16' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200"><radialGradient id="a11" cx=".66" fx=".66" cy=".3125" fy=".3125" gradientTransform="scale(1.5)"><stop offset="0" stop-color="#020103"></stop><stop offset=".3" stop-color="#020103" stop-opacity=".9"></stop><stop offset=".6" stop-color="#020103" stop-opacity=".6"></stop><stop offset=".8" stop-color="#020103" stop-opacity=".3"></stop><stop offset="1" stop-color="#020103" stop-opacity="0"></stop></radialGradient><circle transform-origin="center" fill="none" stroke="url(#a11)" stroke-width="15" stroke-linecap="round" stroke-dasharray="200 1000" stroke-dashoffset="0" cx="100" cy="100" r="70"><animateTransform type="rotate" attributeName="transform" calcMode="spline" dur="2" values="360;0" keyTimes="0;1" keySplines="0 0 1 1" repeatCount="indefinite"></animateTransform></circle><circle transform-origin="center" fill="none" opacity=".2" stroke="#020103" stroke-width="15" stroke-linecap="round" cx="100" cy="100" r="70"></circle></svg>
                                    </div>
                                }

                                {!loading && submitted && drugs?.length > 0 &&
                                    <ul className="suggestions-list list-group list-group-flush">
                                        {drugs.map((item) => (
                                            <li className='list-group-item'
                                                key={item.productId}
                                                onClick={() => handleSuggestionDrugClick(item)}
                                                style={{ cursor: 'pointer' }}
                                            >
                                                {item.productName}
                                            </li>
                                        ))}
                                    </ul>
                                }

                                {!loading && submitted && drugs?.length === 0 && (
                                    <div className='tw-flex tw-items-center tw-justify-center tw-h-full tw-w-full'>
                                        <p>No data found</p>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                </td>
                <td className='ps-0' style={{ width: "19%" }}>
                    <select className="form-select select-input-ui" aria-label="Default select example" name="frequency" value={data.frequency} onChange={addHandleChange}>
                        <option value="">--Select Frequency--</option>
                        {frequencyData?.map((option, i) => (
                            <option key={i} value={option.frequencyId}>{option.name}</option>
                        ))}
                    </select>
                </td>
                <td className='ps-0'>
                    <input type="text" className="form-control control-input-ui" id="Duration" style={{ width: "auto !important" }} placeholder="Duration" name="duration" value={data.duration} onChange={addHandleChange} />
                </td>
                <td className='ps-0'>
                    <input type="text" className="form-control control-input-ui" id="quantity" name="quantity" style={{ width: "auto !important" }} placeholder="Quantity" value={data.quantity} onChange={addHandleChange} />
                </td>
                <td className='ps-0'>
                    <DatePicker
                        dateFormat="dd-MM-yyyy"
                        placeholderText="Supply From"
                        className='form-control control-input-ui'
                        selected={data.supplyFrom}
                        name="supplyFrom"
                        onChange={(date) => addHandleDateChange(date, "supplyFrom")}
                        onKeyDown={(e) => e.preventDefault()}
                        onPaste={(e) => e.preventDefault()}
                        autoComplete='off'
                        style={{ padding: "8px 14px !important" }}
                    />
                </td>
                <td className='ps-0'>
                    <DatePicker
                        dateFormat="dd-MM-yyyy"
                        placeholderText="Supply To"
                        className='form-control control-input-ui'
                        selected={data.supplyTo}
                        disabled={true}
                        name="supplyTo"
                        onChange={(date) => addHandleDateChange(date, "supplyTo")}
                        onKeyDown={(e) => e.preventDefault()}
                        onPaste={(e) => e.preventDefault()}
                        autoComplete='off'
                        style={{ padding: "8px 14px !important" }}
                    />
                </td>
                <td className='ps-0'>
                    <input type="text" className="form-control control-input-ui" id="comments" style={{ width: "auto !important" }} placeholder="Comments" name="comments" value={data.comments} onChange={addHandleChange} />
                </td>
                {/* {showRemoveButton == true &&  */}
                <td className='ps-0'>
                    <button type="button" className="btn-close cross-btn-close" aria-label="Close" onClick={() => removeComponent(c, listType)}></button>
                </td>
                {/* } */}
            </tr >
        </>
    )
}

export default MedicationsSupplierList;